import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';

/* Components */
import ExtendedPropertyCreator from '../common/extended_property/extendedPropertyCreator';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import ModalItemCategories from '../common/forms/modalItemCategories';
import SweetAlert from 'react-bootstrap-sweetalert';

class ModalEdit extends Component {
  constructor(props) {
    super(props);
    const obj = {};
    props.datosDatasource.forEach(item => {
      obj[item.alias] = '';
    });
    this.state = {
      ...obj,
      recipients: props.config.recipients,
      showErrors: false,
      categories: {},
      errorsCategories: {},
      showDisclaimerCategories: false
    };

    // obtiene la fecha de mañana
    this.tomorrow = `${moment().add(1, 'days').format(props.language.account.date.format)} ${props.language.account.others.at} 00:00`;
  }

  componentWillReceiveProps(nextProps) {
    const updateState = {};

    if (this.props.activeUpdate) {
      nextProps.datosDatasource.forEach(item => {
        updateState[item.alias] = '';
      });
      nextProps.config.hom.forEach(item => {
        updateState[item.dataSource] = item.externalEntityId;
      });

      updateState.recipients = nextProps.config.recipients;

      // actualiza el state del componente cuando recibe props actualizados
      this.setState({
        ...this.state,
        ...updateState
      });
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.dataset.type]: e.target.value
    });
  };

  handleSubmit = (event) => {
    const showErrors = Object.keys(this.state.errorsCategories).length > 0;
    this.handleShowErrors(showErrors);

    // si hay errores, detiene la ejecucion
    if (showErrors) {
      return;
    }

    // si no hay errores, envia la informacion
    this.props.handleSubmit(event);
  }

  handleShowErrors = (showErrors) => {
    this.setState({
      showErrors
    });
  }

  handleErrorsCategories = (category, error) => {
    let errorsCategories = this.state.errorsCategories;

    if (error) {
      errorsCategories = {...errorsCategories, [category]: error};
    } else {
      delete errorsCategories[category];
    }

    this.setState({
      errorsCategories
    });
  }

  handleChangeCategories = (event) => {
    let tagSelected = [];
    let categories = this.state.categories;
    categories = {...categories, [event.category]: event};

    // compara si se modificaron los tags seleccionados desde el ultimo estado
    const keys = Object.keys(categories);
    keys.map((key) => {
      const category = categories[key];
      tagSelected = [...tagSelected, ...category.tagSelected];
    });
    // si son distintos, entonces muestra el disclaimer
    const showDisclaimerCategories = (!_.isEqual(this.props.config.tags.sort(), tagSelected.sort())) ? true : false;

    this.setState({
      categories,
      showDisclaimerCategories
    });
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.language.account.modalDriver.editDriverTitle}</h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
            ))}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.statusSave != 200 && (
          <div className={`box-modal max500`}>
            <section id="modal-edit" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.modalDriver.name} <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input type="hidden" defaultValue={this.props.config.id} id="id" />
                  <input
                    data-update="name"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.name}
                    type="text"
                    id="nameup"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.modalDriver.code} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.help.code}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="code"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.code}
                    type="text"
                    id="codeup"
                    className="modal-input"
                  />
                </div>
              </div>
              <div 
                className={"box-form islabel" + (
                  !((this.props.permits.includes('ffdsleep') && this.props.views.includes('ffdsleep'))
                  || (this.props.permits.includes('ffdpvt') && this.props.views.includes('ffdpvt'))) ?
                  " hideWorkingShiftGroup" : ""
                )}
              >
                <div>
                  <label className="modal-label">
                    {this.props.language.account.table.workingShiftGroup} {' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.help.workingShiftGroupHelp}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <select
                    data-update={"workingShiftGroupId"}
                    onChange={this.props.handleChange}
                    value={this.props.config.workingShiftGroupId ? this.props.config.workingShiftGroupId : "" }
                    id={"workingShiftGroupIdup"}
                    className="modal-input temporal-select-style"
                  >
                    <option value="">
                      {this.props.language.account.workingShiftGroup.noWorkingShiftGroup}
                    </option>
                    {
                      this.props.filterWorkingShiftGroups && 
                      this.props.filterWorkingShiftGroups.map((item,i)=>{
                        return (
                          <option key={i} value={item.key}>
                            {item.value}
                          </option>
                        );
                      })
                    }
                  </select>
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.modalDriver.cognusMailConfig.title} {' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.modalDriver.cognusMailConfig.description}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="recipients"
                    type="hidden"
                    id="recipientsup"
                    value={this.state.recipients}
                  />
                  <ReactMultiEmail
                    placeholder={this.props.language.account.modalDriver.cognusMailConfig.placeholder}
                    emails={this.state.recipients}
                    onChange={(emails) => { this.setState({ recipients: emails }); }}
                    validateEmail={email => {
                      return isEmail(email); // return boolean
                    }}
                    getLabel={(email, index, removeEmail) => {
                      return (
                        <div data-tag key={index}>
                          {email}
                          <span data-tag-handle onClick={() => removeEmail(index)}>
                            ×
                          </span>
                        </div>
                      );
                    }}
                  />
                  <div className="module-title left">
                    <p>{this.props.language.account.modalDriver.cognusMailConfig.helpText}</p>
                  </div>
                </div>
              </div>
              <ExtendedPropertyCreator
                prefix="edit-" 
                extendedPropertiesValue={this.props.config.extendedProperties}
                extendedProperties={this.props.extendedProperties}
                onChange={this.props.handleChange}
              />

              {this.props.filter.length > 0 && (
                <Fragment>
                  <div className="module-title left">
                    <h2>
                      {this.props.language.account.others.categories} <strong>(*)</strong> <p>{this.props.language.account.others.selectOnlyOneItem}</p>
                    </h2>
                  </div>

                  {this.props.filter.map((item, i) => (
                    <ModalItemCategories
                      key={`tags-${i}`}
                      index={i}
                      action="update"
                      category={item}
                      language={this.props.language}
                      config={this.props.config}
                      handleChange={this.handleChangeCategories}
                      handleErrors={this.handleErrorsCategories}
                      isMultiple={false}
                    />
                  ))}
    
                  {(this.state.showDisclaimerCategories) && (
                    <div className="alert alert-warning mt-1">
                      <i className="fas fa-exclamation-triangle mr-1" />
                      {this.props.language.account.others.disclaimerCategories} {this.tomorrow}
                    </div>
                  )}
                </Fragment>
              )}

              {this.props.datosDatasource.length > 0 && (
                <div className="module-title left">
                  <h2>{this.props.language.account.modalDriver.dataSource}</h2>
                  <p>{this.props.language.account.modalDriver.dataSourceDescent} </p>
                </div>
              )}

              {this.props.datosDatasource.length > 0 &&
                this.props.datosDatasource.map((item, i) => {
                  return (
                    <div key={i} className="box-form islabel flex align-center top ">
                      <div className="width100">
                        <label className="modal-label padding-reset">{item.alias}:</label>
                      </div>
                      <div>
                        <input
                          onChange={this.handleChange}
                          value={this.state[item.alias]}
                          data-homup={`hom-${i}`}
                          data-type={`${item.alias}`}
                          autoComplete="off"
                          type="text"
                          id={`homup-${i}`}
                          className="modal-input"
                        />
                      </div>
                    </div>
                  );
                })}
            </section>
          </div>
        )}
        {this.props.statusSave != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.handleSubmit}
                  type="button"
                  value={this.props.language.account.modalDriver.buttonEdit}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500`}>
            <section
              className={this.props.dataSave.homologations ? 'feed-back green' : 'feed-back yellow'}
            >
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>
                  {this.props.dataSave.homologations
                    ? this.props.language.account.modalDriver.feedBackDriverOkEdit
                    : this.props.language.account.modalDriver.feedBackDriverWarningEdit}
                </p>
              </div>
            </section>
          </div>
        )}

        {
          (this.state.showErrors) && (
            <SweetAlert
              error
              closeOnClickOutside={true}
              confirmBtnCssClass="confirm-button"
              title={
                <span className="modal-title">
                  <strong>
                    {this.props.language.account.others.formWithErrors}
                  </strong>
                </span>
              }
              onConfirm={() => this.handleShowErrors(false)}
              onCancel={() => this.handleShowErrors(false)}
            >
              <div className="tilte-modal-box">
                {this.props.language.account.others.reviewInformationBeforeSending}
              </div>
            </SweetAlert>
          )
        }
      </div>
    );
  }
}

export default ModalEdit;



// WEBPACK FOOTER //
// ./source/client/components/account_driver/modalEdit.jsx